import { FC, useState } from "react";
import DocumentsPage from "./DocumentsPage";
import CustomBreadCrumbs from "../../../custom-components/CustomBreadCrumbs";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import { useTranslation } from "react-i18next";
import CustomTabulation from "../../../custom-components/CustomTabulation";
import { DocumentsSections } from "../../../domain/enums/DocumentsSectionsEnum";
import useScreenSize from "../../../custom-hooks/base-hooks/useScreenSize";

const Documents: FC = () => {
    const [documentsSection, setDocumentsSection] = useState<DocumentsSections>(DocumentsSections.USER_AGREEMENT);
    const [backgroundBlur, setBackgroundBlur] = useState(false);
    const { upTo800 } = useScreenSize();
    const { t } = useTranslation();

    return (
        <>
            <Header backgroundBlur={backgroundBlur} setBackgroundBlur={setBackgroundBlur} />
            <div className={backgroundBlur ? "relative tmax5:blur" : "relative"}>
                <CustomBreadCrumbs />
                <div className="relative flex flex-col mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px]">
                    <h1 className="H32B dmax2:H24B text-textWhite dmin2:mb-[50px] td3:mb-6">{t("documents.title")}</h1>
                </div>
                {upTo800 && (
                    <div className="relative h-[80px] overflow-x-auto no-scrollbar">
                        <CustomTabulation
                            tabsEnum={DocumentsSections}
                            tabName={documentsSection}
                            tabSwitchHandler={setDocumentsSection}
                            tabTitleKey="documentsSections"
                            wrapClassName="absolute flex justify-start items-center left-0 right-0 min-w-max di6:mx-[26px] ti6:mx-8 ti7:mx-5 tmax4:mx-[15px] pr-[15px] h-full"
                            unorderedListClassName="min-w-[610px] gap-4"
                            listItemClassName="flex items-center"
                            tabNameActiveClassName="H14B text-textWhite pb-1 border-b-2 border-b-[rgba(241,241,241,1)]"
                            tabNameClassName="H14 text-textFaded pb-1 border-b border-b-[rgba(122,122,126,1)]"
                        />
                    </div>
                )}
                <div className="relative flex flex-col mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] dmin2:mb-[200px] td4:mb-[100px] tmax4:mb-[80px] tmax4:min-h-[calc(100vh-152px)] min-h-[600px]">
                    <DocumentsPage documentsSection={documentsSection} setDocumentsSection={setDocumentsSection} />
                </div>
                <Footer />
            </div>
        </>
    );
};

export default Documents;
